
import $ph from '@/plugins/phoenix'
import { session, wallet } from '@/plugins/store';
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class DashboardWidgetBalance extends Vue {
  @Prop(Boolean) readonly loading: boolean | undefined;
  @Prop() readonly settings: any;

  isHovered = false;

  get userBaseCurr(): string {
    return session.user.userBaseCurrency
  }

  get totalAmount(): string {
    return $ph.format(wallet.total, { dec: wallet.baseCurrency.currencyPrecision })
  }

  get vertical(): string {
    const verticalMap = {
      top: 'start',
      center: 'center',
      bottom: 'end',
    };
    return verticalMap[this.settings?.vertical] || 'center'
  }

  get align(): string {
    return this.settings?.align || 'left'
  }

  get dense(): boolean {
    return this.settings?.dense || false
  }

  get cardStyle(): string {
    return this.settings?.background ? `background: ${this.settings.background};` : '';
  }
}
